import React from 'react';
import { Notifier} from "../../ecosystem";

const ErrorMsg = ({
    message,
}) => {

    return (
        <Notifier
            className="proxy-home-error-msg"
            colorStyle="error"
            icon="exclamation">
            {message}
        </Notifier>
    );
}

export default ErrorMsg;
